import * as React from 'react';

var getTabPanes = function getTabPanes(value, children, reRender) {
  var newChildren = React.Children.map(children, function (child, index) {
    var name = child.props.name;
    var isActive = value === undefined && index === 0 ? true : name === value;
    return /*#__PURE__*/React.cloneElement(child, {
      active: isActive,
      reRender: reRender
    });
  });
  return newChildren;
};

var TabContent = function TabContent(_ref) {
  var value = _ref.value,
      children = _ref.children,
      reRender = _ref.reRender;
  return /*#__PURE__*/React.createElement("div", {
    className: "roo-tabs-content"
  }, getTabPanes(value, children, reRender));
};

export default TabContent;